<template>
    <v-dialog v-model="dialog" persistent max-width="700px">
      <template v-slot:activator="{ on, attrs }">
        <v-icon
          color="primary"
          dark
          v-bind="attrs"
          v-on="on"
          small
          class="mx-1"
          >fas fa-pencil-alt
        </v-icon>
      </template>
      <v-card>
        <v-card-title>
          <span class="headline">Edit Subscription</span>
        </v-card-title>
        <v-card-text>
          <v-container>
            <v-form
              ref="form"
              v-model="valid"
            >
            <v-row>
              <v-col cols="12" sm="6" md="4">
                <v-text-field
                  v-model="subscription.product"
                  label="Product"
                  :rules="[v => !!v || 'Item is required']"
                  required
                ></v-text-field>
              </v-col>
              <v-col cols="12" sm="6" md="4">
                <v-menu
                  ref="menu"
                  v-model="menu"
                  :close-on-content-click="false"
                  :return-value.sync="subscription.start_date_date"
                  transition="scale-transition"
                  offset-y
                  min-width="290px"
                >
                  <template v-slot:activator="{ on, attrs }">
                    <v-text-field
                      v-model="subscription.start_date_date"
                      label="Start Date"
                      readonly
                      v-bind="attrs"
                      v-on="on"
                    ></v-text-field>
                  </template>
                  <v-date-picker v-model="subscription.start_date_date" :rules="[v => !!v || 'Item is required']" no-title scrollable>
                    <v-spacer></v-spacer>
                    <v-btn text color="primary" @click="menu = false">Cancel</v-btn>
                    <v-btn text color="primary" @click="$refs.menu.save(subscription.start_date_date)">OK</v-btn>
                  </v-date-picker>
                </v-menu>
              </v-col>
              <v-col cols="12" sm="6" md="4">
                <v-menu
                  ref="menu1"
                  v-model="menu1"
                  :close-on-content-click="false"
                  :return-value.sync="subscription.end_date"
                  transition="scale-transition"
                  offset-y
                  min-width="290px"
                >
                  <template v-slot:activator="{ on, attrs }">
                    <v-text-field
                      v-model="subscription.end_date"
                      label="End Date"
                      readonly
                      v-bind="attrs"
                      v-on="on"
                    ></v-text-field>
                  </template>
                  <v-date-picker v-model="subscription.end_date" :rules="[v => !!v || 'Item is required']" no-title scrollable>
                    <v-spacer></v-spacer>
                    <v-btn text color="primary" @click="menu1 = false">Cancel</v-btn>
                    <v-btn text color="primary" @click="$refs.menu1.save(subscription.end_date)">OK</v-btn>
                  </v-date-picker>
                </v-menu>
              </v-col>
              <v-col cols="12" sm="6" md="4">
                <v-select
                  v-model="subscription.type"
                  :items="['Domain','SSL Certificate','Hosting','Gsuit','Ads']"
                  :rules="[v => !!v || 'Item is required']"
                  label="Type"
                  required
                ></v-select>
              </v-col>
              
              <v-col cols="12" sm="6" md="4">
                <v-select
                  v-model="subscription.client_id"
                  :items="allclients"
                  item-text="name"
                  item-value="id"
                  :rules="[v => !!v || 'Item is required']"
                  label="Client"
                  required
                ></v-select>
              </v-col>
              <v-col cols="12" sm="6" md="4">
                 <v-select
                  v-model="subscription.status"
                  :items="['Running','Suspended']"
                  :rules="[v => !!v || 'Item is required']"
                  label="subscription Status"
                  required
                ></v-select>
              </v-col>
              
            </v-row>
            </v-form>
          </v-container>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="blue darken-1" text @click="dialog = false">Close</v-btn>
          <v-btn color="success darken-1" text :disabled="!valid" @click="editsubscription1()">Save</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
</template>

<script>
import { mapGetters,mapActions } from 'vuex';
  export default {
    props : {
        subscriptionid: Number
    },
    data: () => ({
      menu: '',
      menu1: '',
      valid: true,
      data: {},
      dialog: false,
      subscription: '',
    }),
    computed: {
      ...mapGetters(["allclients","allsalesperson","allusers",'allsubscriptions']),
    },
    created () {
      let subscription1 = this.allsubscriptions.filter(product => product.id === this.subscriptionid);
      this.subscription = subscription1[0];
    },
    methods:{
      ...mapActions(['editsubscription','fetchsubscriptions']),
      editsubscription1() {
        if(this.$refs.form.validate())
        {
          this.editsubscription(this.subscription);
          this.dialog = false;
        }
      }
    }
  }
</script>